import styles from './header-badge.module.scss';
import { classNames } from 'tradera/utils/class-names';

type HeaderBadgeProps = {
    count: number;
    maxValue?: number;
};
export const HeaderBadge = ({ count, maxValue = 99 }: HeaderBadgeProps) => (
    <span
        className={classNames(
            'text-inter-medium bg-dark text-light size-oslo',
            styles.badge
        )}>
        {count > maxValue ? `${maxValue}+` : count}
    </span>
);
